export type AspectRatio = '1:1' | '9:16' | '16:9' | '5:4' | '4:5'
export const getRatio = (ratio?: AspectRatio) => {
  if (ratio === '16:9') return 'aspect-16/9'
  if (ratio === '1:1') return 'aspect-1/1'
  if (ratio === '9:16') return 'aspect-9/16'
  if (ratio === '5:4') return 'aspect-5/4'
  if (ratio === '4:5') return 'aspect-4/5'
  return ''
}
